import React, { useEffect, useState } from "react";
import { Button, Select, Table, Tooltip, Input } from "antd";
import { useNavigate } from "react-router-dom";
import { EyeFilled } from "@ant-design/icons";
import "../../css/common.css";
import { post } from "../../../services/services";
import { ApiURL } from "../../../services/apiConstants";
import { formatDate } from "../../../utils/dateFormatter";

const DailyShipStaffTask = () => {
  const navigate = useNavigate();
  const [page_loader, set_page_loader] = useState(false);
  const [filteredData, setFilteredData] = useState([]);
  const [ship_id, set_ship_id] = useState("");
  const [ship_table_list, set_ship_table_list] = useState([]);
  const [searchText, setSearchText] = useState("");

  const displayedData = filteredData?.filter(
    (item) =>
      (item.task_details || "")
        .toLowerCase()
        .includes(searchText.toLowerCase()) ||
      (item.department || "")
        .toLowerCase()
        .includes(searchText.toLowerCase()) ||
      (item.staff_role || "")
        .toLowerCase()
        .includes(searchText.toLowerCase()) ||
      (item.component || "").toLowerCase().includes(searchText.toLowerCase()),
  );

  const SHIP_LIST_API = () => {
    try {
      const FORM_DATA = new FormData();
      post(ApiURL.list_ships_view_com, FORM_DATA).then((res) => {
        if (res?.status == true) {
          set_ship_table_list(res?.ships);
          set_ship_id(res?.ships[0]?.id);
          LIST_DAILY_SHIP_STAFF_TASK_API(res?.ships[0]?.id);
        }
      });
    } catch (error) {
      console.error("Error fetching ship list:", error);
    }
  };

  const LIST_DAILY_SHIP_STAFF_TASK_API = async (ship_id) => {
    set_page_loader(true);
    try {
      const FORM_DATA = new FormData();
      FORM_DATA.append("ship_id", ship_id);
      post(ApiURL.company_listing_daily_task_report, FORM_DATA).then((res) => {
        if (res?.status == true) {
          setFilteredData(res?.data);
        }
        set_page_loader(false);
      });
    } catch (error) {
      console.error("Error fetching Staff list:", error);
      set_page_loader(false);
    }
  };

  useEffect(() => {
    SHIP_LIST_API();
  }, []);

  const columns = [
    {
      title: "Id",
      dataIndex: "id",
      align: "center",
      key: "id",
      sorter: (a, b) => a.id - b.id,
    },
    {
      title: "Staff Role",
      dataIndex: "staff_role",
      align: "center",
      key: "staff_role",
    },
    {
      title: "Task Details",
      dataIndex: "task_details",
      align: "center",
      key: "task_details",
      width: 300,
    },
    {
      title: "Department",
      dataIndex: "department",
      align: "center",
      key: "department",
    },
    {
      title: "Component",
      dataIndex: "component",
      align: "center",
      key: "component",
    },
    {
      title: "Remark By Staff Role",
      dataIndex: "staff_role",
      align: "center",
      key: "staff_role",
    },
    {
      title: "Created Date",
      dataIndex: "created_at",
      align: "center",
      key: "created_at",
      render: (text, record) => formatDate(record?.created_at),
    },
    {
      title: "Updated Date",
      dataIndex: "updated_at",
      align: "center",
      key: "updated_at",
      render: (text, record) => formatDate(record?.updated_at),
    },
    {
      title: "Action",
      align: "center",
      key: "Action",
      render: (text, record) => {
        return (
          <>
            {!record?.soft_delete && (
              <Tooltip title="View">
                <Button
                  type="primary"
                  size="small"
                  onClick={() =>
                    navigate(`/view-daily-ship-staff-task/${btoa(record?.id)}`)
                  }
                  style={{ marginRight: "15px" }}
                  icon={<EyeFilled />}
                />
              </Tooltip>
            )}
          </>
        );
      },
    },
  ];

  return (
    <>
      <div className="row">
        <div
          className="col-3"
          style={{ marginBottom: "13px", marginLeft: "15px" }}
        >
          <label className="block-label">Select Ship</label>
          <Select
            placeholder="---- Select Ship ----"
            style={{ width: "100%" }}
            value={ship_id}
            onChange={(value) => {
              set_ship_id(value);
              LIST_DAILY_SHIP_STAFF_TASK_API(value);
            }}
          >
            {ship_table_list?.length > 0 && (
              <>
                {ship_table_list.map((ship) => (
                  <>
                    {!ship.soft_delete && (
                      <>
                        <Select.Option key={ship.id} value={ship.id}>
                          {ship.vessel_name}
                        </Select.Option>
                      </>
                    )}
                  </>
                ))}
              </>
            )}
          </Select>
        </div>

        <div className="col-3" style={{ marginBottom: "13px" }}>
          <label className="block-label">Search</label>
          <Input
            placeholder="Search by task, dept, role, component..."
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
            style={{ width: "100%" }}
            allowClear
          />
        </div>
      </div>

      <div className="row" style={{ padding: "10px" }}>
        <div className="col-3" style={{ marginLeft: "5px", alignSelf: "end" }}>
          <div className="theme-content-title text-left">
            <h3>Daily Ship Staff Task</h3>
          </div>
        </div>
        <div className="col-3"></div>
        <div
          className="col-6"
          style={{ display: "flex", justifyContent: "flex-end" }}
        >
          <div className="d-flex align-items-center">
            <Button
              type="primary"
              className="save_btn"
              onClick={() => navigate("/view-audit-trail-daily-com")}
            >
              Audit Trail
            </Button>
          </div>
        </div>
      </div>
      <Table
        bordered
        loading={page_loader}
        columns={columns}
        dataSource={displayedData}
        pagination={{ pageSize: 10 }}
        rowKey="key"
        className="custom-table"
      />
    </>
  );
};

export default DailyShipStaffTask;
